/** @format */

import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { logger } from "@goldenbird1/ui-logger-library";
import { connect } from "react-redux";
import SellerLandingDesktop from "./SellerLandingDesktop";
import SellerLandingMobile from "../mobile/SellerLandingMobile";
import { getSellerDetails } from "../../store/actions";
// import { useKeycloak } from "@react-keycloak/ssr";
import { useRouter } from "next/router";
import _groupBy from "lodash/groupBy";
import { pageLoad } from "../../utils/GTMDataLayer";
import { accessToken } from "../../utils/accessToken";
import { enquireScreen } from "enquire-js";
import { v4 as uuidv4 } from "uuid";
const isServer = () => typeof window == "undefined";

const SellerLanding = (props) => {
  const router = useRouter();
  // let { sellerId: sellerIdParam } = router.query;
  let sellerIdParam = router.query['sellerId'] || '';
  let { userProfile = {}, isLoading = true } = props;

  // const { keycloak } = useKeycloak();
  const [cookies, setCookie] = useCookies([""]);
  // let token = "";
  // if(localStorage.getItem('kcAccessToken')){
  //   token = localStorage.getItem('kcAccessToken');
  // }
  const [mobile, setMobile] = useState(false);
  const [sellerSubscriptions, setSellerSubscriptions] = useState([]);
  const [aboutCompany, setAboutCompany] = useState(props.data.about);
  const [productPopupDetails, setProductPopupDetails] = useState(
    props.data.category_product_range
  );
  const [sellerDetails, setSellerDetails] = useState(props.data.sellerDetails);
  const [count, setCount] = useState(0);

  let token = "";
  token = accessToken();
  
  useEffect(() => {
    token = accessToken();
    // if(!token){
    //   router.push('/signin');
    // }
  }, []);

  let app_token = null;

  if (token) {
    app_token = token;
  } else {
    app_token = process.env.NEXT_PUBLIC_ANONYMOUS_TOKEN;
  }
  useEffect(() => {
    pageLoad("seller landing page", "landing page");
  }, []);

  const getSellerHomeDetails = (id) => {
    if(id){
      let buyerId = props.userProfile && props.userProfile?.profileId ? props.userProfile.profileId : null;
      let url = `${process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL}/profile/seller-home/ABOUT::SELLER::${id}/about`;
     fetch(
        url,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + app_token,
            'trace-id' : uuidv4()
          },
        }
      )
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then((result) => {
        let aboutCompany =
          result.length > 0 ? result[0]["htmlContent"] : "";
        setAboutCompany(aboutCompany);
      })
      .catch((err) => {
        console.log(err.message);
        logger("error", "Error from getSellerHomeDetails method SellerLanding: " + url + ": buyerId =>  "+buyerId+ ': error => ' +err?.statusText, process.env.NEXT_PUBLIC_LOGGER_URL);
        if(err.status === 401){
          router.push('/signin');
        }
      });
    }
  }

  const addToRVSeller = (id) => {
    if(id && token && typeof token === 'string'){
      let buyerId = props.userProfile && props.userProfile?.profileId ? props.userProfile.profileId : null;
      let url = `${process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL}/collections/v1/recently/viewed/add/seller?seller_code=${id}`;
      fetch(
        url,
        {
          method: "POST",
          headers: {
            // "Content-Type": "application/json",
            Authorization: "Bearer " + token,
            'trace-id' : uuidv4()
          },
        }
      )
      .then((res) => {
        if (res.ok) {
          // console.log("Added seller to recently viewed");
        } else {
          throw res;
        }
      })
      .catch((err) => {
        console.log(err.message);
        logger("error", "Error from addToRVSeller method SellerLanding: " + url + ": buyerId =>  "+buyerId+ ': error => ' +err?.statusText, process.env.NEXT_PUBLIC_LOGGER_URL);
        if(err.status === 401){
          router.push('/signin');
        }
      });
    }
  }
  const subscribeBuyer = (profileType, verificationStatus) => {
    if (profileType === "BUYER" && verificationStatus === "IN_PROGRESS") {
      let url = process.env.NEXT_PUBLIC_REACT_APP_API_PROFILE_URL +
          "/profiles/my/subscriptions";
      let buyerId = props.userProfile && props.userProfile?.profileId ? props.userProfile.profileId : null;
      
      fetch(
        url,
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then((response) => {
        setSellerSubscriptions(response["sellerSubscriptions"]);
      })
      .catch((err) => {
        logger("error", "Error from subscribeBuyer method SellerLanding: " + url + ": buyerId =>  "+buyerId+ ': error => ' +err?.statusText, process.env.NEXT_PUBLIC_LOGGER_URL);
        if(err.status === 401){
          router.push('/signin');
        }
        // console.log("Error ", err);
      });
    }
  }
  let retryCountSD = 0;
  const getSD = (profileType, verificationStatus) => {
    props.getSellerDetails(
      app_token,
      sellerIdParam,
      false,
      (result) => {
        let { error = "" } = result;
        if(!error){
          setSellerDetails(result);
          let id = result?.id?.replace("HOME::", "");
          id = id?.replace("SELLER::", "");
          getSellerHomeDetails(id);
          addToRVSeller(id);
        }else{
          if (retryCountSD < 3) {
            getSD(profileType, verificationStatus);
          } else {
            console.log("Get Seller details API Failed!");
          }
          retryCountSD++;
        }
      }
    );
  }

  useEffect(() => {
    enquireScreen((status) => setMobile(status));
    let verificationStatus = "";
    let profileType = "";
    if (props.userProfile) {
      verificationStatus = props.userProfile.verificationStatus;
      profileType = props.userProfile.profileType;
    }
    getSD(profileType, verificationStatus);
    subscribeBuyer(profileType, verificationStatus);
    setCount(1);
  }, [router.query]);

  const categoryRange = () => {
    let productTypes = _groupBy(props.data.category_product_range, "l2Desc");

    let values = [];
    for (let list in productTypes) {
      let obj = {};
      obj["productType"] = list;
      let pDetails = "";
      let l1Desc = "";
      for (let items of productTypes[list]) {
        let { productTypeDesc = "" } = items;
        l1Desc = items["l1Desc"];
        pDetails = pDetails + productTypeDesc + ", ";
      }
      let pName = pDetails.trim().slice(0, -1);
      obj["productName"] = pName;
      obj["l1Desc"] = l1Desc;
      values.push(obj);
    }
    return values;
  };
  return (
    <div>
      {mobile ? (
        <SellerLandingMobile
          data={!isServer() ? sellerDetails : props.data.sellerDetails}
          isLoading={isServer() ? isLoading : false}
          userProfile={userProfile}
          token={app_token}
          sellerSubscriptions={sellerSubscriptions}
          aboutCompany={!isServer() ? aboutCompany : props.data.about}
          productPopupDetails={
            !isServer() ? productPopupDetails : categoryRange()
          }
          sellerIdentity={(sellerDetails && sellerDetails.kcIdentityId) || null}
        />
      ) : (
        <SellerLandingDesktop
          data={!isServer() ? sellerDetails : props.data.sellerDetails}
          isLoading={isServer() ? isLoading : false}
          userProfile={userProfile}
          token={app_token}
          sellerSubscriptions={sellerSubscriptions}
          productPopupDetails={
            !isServer() ? productPopupDetails : categoryRange()
          }
          aboutCompany={!isServer() ? aboutCompany : props.data.about}
          sellerIdentity={(sellerDetails && sellerDetails.kcIdentityId) || null}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userProfile: state.userProfile.userProfile,
    isLoading: state.sellerListing.isLoading,
  };
};

export default connect(mapStateToProps, { getSellerDetails })(SellerLanding);
